(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anteqaat-product-luxury"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('.aq-product-luxury').forEach(root => {
        if (root.dataset.aqLuxuryReady) return;
        root.dataset.aqLuxuryReady = 'true';
        const prepareOptions = event => {
          if (event.type === 'click' && !event.target.closest('.product-form__submit, .shopify-payment-button')) return;
          if (event.type === 'submit' && !event.target.closest('product-form')) return;
          const gift = root.querySelector('.aq-luxury-gift');
          if (gift) gift.open = true;
          root.querySelectorAll('.aq-luxury-note').forEach(note => { note.open = true; });
        };
        root.addEventListener('click', prepareOptions, true);
        root.addEventListener('submit', prepareOptions, true);
        const copy = root.querySelector('.aq-luxury-copy')?.dataset;
        if (!copy) return;
        const enhance = () => {
          const box = root.querySelector('#ymq-box');
          if (!box) return;
          if (!box.closest('.aq-luxury-gift')) {
            const details = document.createElement('details');
            details.className = 'aq-luxury-gift';
            details.open = [...box.querySelectorAll('.ymq-options-box')].some(field => /الاسم|حفر/.test(field.dataset.label || ''));
            const summary = document.createElement('summary');
            const words = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = copy.giftTitle;
            const subtitle = document.createElement('small');
            subtitle.textContent = copy.giftSubtitle;
            words.append(title, subtitle);
            const plus = document.createElement('span');
            plus.textContent = '+';
            plus.setAttribute('aria-hidden', 'true');
            summary.append(words, plus);
            details.append(summary);
            box.before(details);
            details.append(box);
          }
          const rename = (selector, value) => {
            const element = box.querySelector(selector);
            if (element && element.textContent !== value) element.textContent = value;
          };
          rename('#option-box-16tem1 .ymq_lable', copy.cardLabel);
          rename('#option-box-16tem2 .ymq_lable', copy.noteLabel);
          rename('#option-box-18tem1 .ymq_lable', copy.extrasLabel);
          rename('label[for="ymq-attrib-16tem3_4"] .ymq-option-value', copy.withWrap);
          rename('label[for="ymq-attrib-16tem3_3"] .ymq-option-value', copy.withoutWrap);
          box.querySelectorAll('.ymq-input-text').forEach(input => {
            const label = input.closest('.ymq-options-box')?.querySelector('.ymq_lable');
            if (!label || !input.id) return;
            if (!label.id) label.id = `${input.id}-label`;
            if (!input.hasAttribute('aria-labelledby')) input.setAttribute('aria-labelledby', label.id);
          });
          const note = box.querySelector('#option-box-16tem2');
          if (note && !note.closest('.aq-luxury-note')) {
            const details = document.createElement('details');
            details.className = 'aq-luxury-note';
            const summary = document.createElement('summary');
            summary.textContent = copy.noteLabel;
            details.append(summary);
            note.before(details);
            details.append(note);
          }
          const required = box.querySelector('input[required], select[required], textarea[required], .ymq-required');
          if (required) box.closest('.aq-luxury-gift').open = true;
          const error = [...box.querySelectorAll('.ymq-error-box')].some(e => e.textContent.trim());
          if (error) box.closest('.aq-luxury-gift').open = true;
        };
        let pending = false;
        const observer = new MutationObserver(() => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => { pending = false; enhance(); });
        });
        observer.observe(root, { childList:true, subtree:true });
        enhance();
        root.addEventListener('invalid', event => {
          const gift = event.target.closest('.aq-luxury-gift');
          if (gift) gift.open = true;
          const note = event.target.closest('.aq-luxury-note');
          if (note) note.open = true;
        }, true);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) observer.disconnect();
        }, { once:true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once:true });
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anteqaat-product-sample"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('.aq-product-sample').forEach(root => {
        if (root.dataset.aqSampleReady) return;
        root.dataset.aqSampleReady = 'true';
        const gallery = root.querySelector('.aq-sample-gallery');
        gallery?.addEventListener('click', event => {
          const button = event.target.closest('.aq-sample-thumbnail');
          if (!button) return;
          const picture = gallery.querySelector('.aq-sample-image');
          const link = gallery.querySelector('.aq-sample-image-link');
          picture.removeAttribute('srcset');
          picture.src = button.dataset.image;
          picture.alt = button.dataset.alt;
          picture.width = Number(button.dataset.width);
          picture.height = Number(button.dataset.height);
          link.href = button.dataset.image;
          gallery.querySelectorAll('.aq-sample-thumbnail').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
        const prepareOptions = event => {
          if (event.type === 'click' && !event.target.closest('.product-form__submit, .shopify-payment-button')) return;
          if (event.type === 'submit' && !event.target.closest('product-form')) return;
          const gift = root.querySelector('.aq-sample-gift');
          if (gift) gift.open = true;
        };
        root.addEventListener('click', prepareOptions, true);
        root.addEventListener('submit', prepareOptions, true);
        const copy = root.querySelector('.aq-sample-copy')?.dataset;
        if (!copy) return;
        const enhance = () => {
          const box = root.querySelector('#ymq-box');
          if (!box) return;
          if (!box.closest('.aq-sample-gift')) {
            const details = document.createElement('details');
            details.className = 'aq-sample-gift';
            const summary = document.createElement('summary');
            const words = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = copy.giftTitle;
            const subtitle = document.createElement('small');
            subtitle.textContent = copy.giftSubtitle;
            words.append(title, subtitle);
            const plus = document.createElement('span');
            plus.textContent = '+';
            plus.setAttribute('aria-hidden', 'true');
            summary.append(words, plus);
            details.append(summary);
            box.before(details);
            details.append(box);
          }
          const rename = (selector, value) => {
            const element = box.querySelector(selector);
            if (element && element.textContent !== value) element.textContent = value;
          };
          rename('#option-box-16tem1 .ymq_lable', copy.cardLabel);
          rename('#option-box-16tem2 .ymq_lable', copy.noteLabel);
          rename('#option-box-18tem1 .ymq_lable', copy.extrasLabel);
          rename('label[for="ymq-attrib-16tem3_4"] .ymq-option-value', copy.withWrap);
          rename('label[for="ymq-attrib-16tem3_3"] .ymq-option-value', copy.withoutWrap);
          box.querySelectorAll('.ymq-input-text').forEach(input => {
            const label = input.closest('.ymq-options-box')?.querySelector('.ymq_lable');
            if (!label || !input.id) return;
            if (!label.id) label.id = `${input.id}-label`;
            if (!input.hasAttribute('aria-labelledby')) input.setAttribute('aria-labelledby', label.id);
          });
          const note = box.querySelector('#option-box-16tem2');
          if (note && !note.closest('.aq-sample-note')) {
            const details = document.createElement('details');
            details.className = 'aq-sample-note';
            const summary = document.createElement('summary');
            summary.textContent = copy.noteLabel;
            details.append(summary);
            note.before(details);
            details.append(note);
          }
          const error = [...box.querySelectorAll('.ymq-error-box')].some(e => e.textContent.trim());
          if (error) box.closest('.aq-sample-gift').open = true;
        };
        let pending = false;
        const observer = new MutationObserver(() => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => { pending = false; enhance(); });
        });
        observer.observe(root, { childList:true, subtree:true });
        enhance();
        root.addEventListener('invalid', event => {
          const gift = event.target.closest('.aq-sample-gift');
          if (gift) gift.open = true;
          const note = event.target.closest('.aq-sample-note');
          if (note) note.open = true;
        }, true);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) observer.disconnect();
        }, { once:true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once:true });
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anteqaat-refinement"] && !Shopify.designMode) return;
  try {
    (()=>{
    if(document.documentElement.lang!=='ar')return;
    const translations=new Map([
      ['Cookie consent','تفضيلات ملفات تعريف الارتباط'],['Manage preferences','إدارة التفضيلات'],['Accept','قبول'],['Decline','رفض'],['Privacy Policy','سياسة الخصوصية'],['Cookie preferences','تفضيلات ملفات تعريف الارتباط'],['Save preferences','حفظ التفضيلات'],['Accept all','قبول الكل'],['Reject all','رفض الكل'],['Close','إغلاق'],['Required','ضرورية'],['Preferences','التفضيلات'],['Analytics','التحليلات'],['Marketing','التسويق'],['Data sale','بيع البيانات'],['We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our','نستخدم نحن وشركاؤنا، بما في ذلك Shopify، ملفات تعريف الارتباط وتقنيات أخرى لتخصيص تجربتك وعرض الإعلانات وإجراء التحليلات. ولن نستخدمها لهذه الأغراض إلا بموافقتك. اعرف المزيد في'],

      ['Let customers speak for us','آراء عملائنا'],['Customer Reviews','تقييمات العملاء'],['Write a review','اكتب تقييمًا'],['Write a Review','اكتب تقييمًا'],['Be the first to write a review','كن أول من يقيّم هذا المنتج'],['Verified','شراء موثّق'],['Verified Buyer','مشتري موثّق'],['Verified buyer','مشتري موثّق'],['Read more','اقرأ المزيد'],['Read less','عرض أقل'],['Previous reviews','التقييمات السابقة'],['Next reviews','التقييمات التالية'],['Start a Conversation','تواصل معنا'],['Search','بحث'],['Sort by:','الترتيب حسب:'],['Featured','مختاراتنا'],['Most relevant','الأكثر صلة'],['Best selling','الأكثر مبيعًا'],['Alphabetically, A-Z','الاسم: تصاعديًا'],['Alphabetically, Z-A','الاسم: تنازليًا'],['Price, low to high','السعر: من الأقل إلى الأعلى'],['Price, high to low','السعر: من الأعلى إلى الأقل'],['Date, old to new','الأقدم أولًا'],['Date, new to old','الأحدث أولًا']
    ]);
    function translate(root){
      const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
      const nodes=[];let node;
      while((node=walker.nextNode()))nodes.push(node);
      for(const n of nodes){
        if(n.parentElement?.closest('script,style,textarea,input'))continue;
        const text=n.nodeValue.trim();let replacement=translations.get(text);
        const count=text.match(/^from ([\d,.]+) reviews$/i);
        if(count)replacement='من '+count[1]+' تقييمًا';
        if(replacement&&text!==replacement)n.nodeValue=n.nodeValue.replace(text,replacement);
      }
      root.querySelectorAll('[aria-label]').forEach(el=>{const label=el.getAttribute('aria-label');if(translations.has(label))el.setAttribute('aria-label',translations.get(label));});
    }
    let scheduled=false;
    const run=()=>{scheduled=false;document.querySelectorAll('.jdgm-widget,.jdgm-carousel-wrapper,.facets-container,.waj-parent,#shopify-pc__banner,.shopify-pc__prefs__dialog').forEach(translate);};
    const init=()=>{run();new MutationObserver(mutations=>{if(!scheduled&&mutations.some(m=>m.addedNodes.length)){scheduled=true;requestAnimationFrame(run);}}).observe(document.body,{childList:true,subtree:true});};
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
